import { Typography } from '@mui/material';
import EAIcon from 'components/common/EAIcon';
import i18next from 'i18next';
import {
  EVSupplierAdditionalAddress,
  EVSupplierAdditionalInformations,
  EVSupplierGeneralIdentifiers,
  getCountryName,
  hasOneNotEmptyValue,
} from 'services/common/EcovadisUtils';
import useStyles from 'style/js-style/components/thirdparties/ecovadis/EcovadisStyle';
import EcovadisDialogButtons from '../EcovadisDialogButtons';

const BlocTitle = ({ icon, title }) => {
  const { classes } = useStyles();
  return (
    <Typography className={classes.foundSupplierInfoBlocTitle}>
      <EAIcon icon={icon} />
      <span>{title}</span>
    </Typography>
  );
};

const EcovadisFoundSupplier = ({
  supplier,
  messageType = '', // 'new' | 'exists'
  integrationId,
  onCancel = () => {},
  onValidate = () => {},
  shouldTrigger = true,
  isValidationLoading = false
}) => {
  const { classes } = useStyles();

  return (
    <div className={classes.foundSupplierStep}>
      <Typography className={classes.stepTitle}>
        {i18next.t(`ecovadis.foundSupplier.${messageType}`, {integrationId})}
      </Typography>

      <div className={classes.foundSupplierInfos}>
        <div className={classes.foundSupplierName}>
          {supplier?.ev_supplier_name || supplier?.client_supplier_name}
        </div>
        <div className={classes.foundSupplierActivity}>
          {supplier?.isic_category}
        </div>
        <div className={classes.foundSupplierBlocs}>
          {/* Coordinates bloc */}
          {hasOneNotEmptyValue(
            supplier,
            Object.values(EVSupplierAdditionalAddress)
          ) && (
            <div className={classes.foundSupplierInfoBloc}>
              <BlocTitle
                title={i18next.t('thirdpartySheet.coordinates')}
                icon="coordinate"
              />
              <div>{supplier?.address_1}</div>
              <div>{supplier?.address_2}</div>
              <div>{supplier?.city}</div>
              <div>{supplier?.state}</div>
              {supplier?.country && (
                <div>{getCountryName(supplier?.country)?.toUpperCase()}</div>
              )}
            </div>
          )}

          {/* Informations bloc */}
          {hasOneNotEmptyValue(
            supplier,
            Object.values(EVSupplierAdditionalInformations)
          ) && (
            <div className={classes.foundSupplierInfoBloc}>
              <BlocTitle title={i18next.t('informations')} icon="information" />
              {Object.values(EVSupplierAdditionalInformations).map(
                (key) =>
                  supplier?.[key] && (
                    <div key={key}>
                      {i18next.t(key)} :{' '}
                      <span className={classes.foundSupplierInfoBlocValue}>
                        {key === EVSupplierAdditionalInformations.TURNOVER ? (
                          <>{supplier[key].replaceAll('_', ' ').trim()} USD</>
                        ) : (
                          <>{supplier[key]}</>
                        )}
                      </span>
                    </div>
                  )
              )}
            </div>
          )}

          {/* Identifiers bloc */}
          {hasOneNotEmptyValue(
            supplier,
            Object.values(EVSupplierGeneralIdentifiers)
          ) && (
            <div className={classes.foundSupplierInfoBloc}>
              <BlocTitle title={i18next.t('identifiers')} icon="information" />
              {Object.values(EVSupplierGeneralIdentifiers).map(
                (key) =>
                  supplier?.[key] && (
                    <div key={key}>
                      {supplier?.[key]} (
                      {i18next.t(`ecovadis.identifiers.${key}`)})
                    </div>
                  )
              )}
            </div>
          )}
        </div>
      </div>

      <EcovadisDialogButtons onCancel={onCancel} onValidate={onValidate} shouldTrigger={shouldTrigger} isLoading={isValidationLoading}/>
    </div>
  );
};

export default EcovadisFoundSupplier;
